import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, Typography, Button, Flex, Grid } from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"
import { spacings } from "themes/variables"

const { Text } = Typography

export const CrewMemberTable = ({ data, onEdit, onRemove }) => {
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isMobile = !screens.md

  const columns = useMemo(
    () => [
      {
        title: "Staff Member Name",
        dataIndex: "name",
        key: "name",
        width: 180,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Text fw="500">
            {record.name || `${record.first_name || ""} ${record.last_name || ""}`.trim() || "-"}
          </Text>
        )
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        align: "left",
        width: 120,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (role) => <Text>{role?.name || "-"}</Text>
      },
      {
        title: "Actions",
        key: "action",
        align: "right",
        width: 100,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Flex gap={spacings.XS} justify="end">
            <Button
              type="text"
              icon={<EditOutlined className={styles.editIcon} />}
              onClick={() => onEdit(record)}
              aria-label="Edit crew member"
            />
            <Button
              type="text"
              icon={<DeleteOutlined className={styles.deleteIcon} />}
              onClick={() => onRemove(record.id)}
              className={styles.removeExperienceButton}
              aria-label="Remove crew member"
            />
          </Flex>
        )
      }
    ],
    [onEdit, onRemove]
  )

  if (isMobile) {
    return (
      <Flex vertical gap={spacings.S} className="mt-s">
        {data.map((record) => (
          <div key={record.id} className={styles.mobileCard}>
            <Flex vertical gap={spacings.XS}>
              <Text fw="500">
                {record.name || `${record.first_name || ""} ${record.last_name || ""}`.trim() || "-"}
              </Text>
              <Flex gap={spacings.XS} align="center">
                <Text className={styles.mobileCardLabel}>Role:</Text>
                <Text>{record.role?.name || "-"}</Text>
              </Flex>
            </Flex>
            <Flex gap={spacings.XS} justify="end" className={styles.mobileCardActions}>
              <Button
                type="text"
                icon={<EditOutlined className={styles.editIcon} />}
                onClick={() => onEdit(record)}
                aria-label="Edit crew member"
              />
              <Button
                type="text"
                icon={<DeleteOutlined className={styles.deleteIcon} />}
                onClick={() => onRemove(record.id)}
                className={styles.removeExperienceButton}
                aria-label="Remove crew member"
              />
            </Flex>
          </div>
        ))}
      </Flex>
    )
  }

  return <Table className={styles.crewMemberTable} dataSource={data} rowKey="id" pagination={false} columns={columns} scroll={{ x: "max-content", y: 300 }} />
}

CrewMemberTable.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}
